import { Typography } from '@mui/material';
import type { TabProps } from 'react-tabs';
import { Tab } from 'react-tabs';
import './style.css';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props extends TabProps {
  children: string;
  enableDarkTheme?: boolean;
}

// Custom Tab component without underline and with color adjustments for unselected state
const SWTab = ({ children, enableDarkTheme = false, ...rest }: Props) => {
  const isSelected = rest.selected;

  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <Tab
      {...rest}
      style={{
        backgroundColor: isSelected ? palette.primary : 'transparent',
        borderColor: palette.primary,
        color: isSelected ? palette.white : undefined,
      }}
    >
      <Typography
        variant="medium"
        sx={{
          color: isSelected
            ? palette.white
            : enableDarkTheme
            ? palette.lightGrey
            : palette.textSecondary,
          fontWeight: isSelected ? 'bold' : 'normal',
          padding: '8px 16px',
          transition: 'color 0.3s ease',
        }}
      >
        {children}
      </Typography>
    </Tab>
  );
};

SWTab.tabsRole = 'Tab'; // Required field for custom Tab

export default SWTab;
